import { __assign } from "tslib";
import { typeFromAST, TypeInfo, visit, visitWithTypeInfo, Kind, } from 'graphql';
import { MapperKind, mapSchema, transformInputValue } from '@graphql-tools/utils';
var TransformInputObjectFields = /** @class */ (function () {
    function TransformInputObjectFields(inputFieldTransformer, inputFieldNodeTransformer, inputObjectNodeTransformer) {
        this.inputFieldTransformer = inputFieldTransformer;
        this.inputFieldNodeTransformer = inputFieldNodeTransformer;
        this.inputObjectNodeTransformer = inputObjectNodeTransformer;
        this.mapping = {};
    }
    TransformInputObjectFields.prototype.transformSchema = function (originalWrappingSchema, _subschemaConfig, _transformedSchema) {
        var _a;
        var _this = this;
        this.transformedSchema = mapSchema(originalWrappingSchema, (_a = {},
            _a[MapperKind.INPUT_OBJECT_FIELD] = function (inputFieldConfig, fieldName, typeName) {
                var transformedInputField = _this.inputFieldTransformer(typeName, fieldName, inputFieldConfig);
                if (Array.isArray(transformedInputField)) {
                    var newFieldName = transformedInputField[0];
                    if (newFieldName !== fieldName) {
                        if (!(typeName in _this.mapping)) {
                            _this.mapping[typeName] = {};
                        }
                        _this.mapping[typeName][newFieldName] = fieldName;
                    }
                }
                return transformedInputField;
            },
            _a));
        return this.transformedSchema;
    };
    TransformInputObjectFields.prototype.transformRequest = function (originalRequest, delegationContext, _transformationContext) {
        var _this = this;
        var variableValues = originalRequest.variables;
        var fragments = Object.create(null);
        var operations = [];
        originalRequest.document.definitions.forEach(function (def) {
            if (def.kind === Kind.OPERATION_DEFINITION) {
                operations.push(def);
            }
            else {
                fragments[def.name.value] = def;
            }
        });
        operations.forEach(function (def) {
            var variableDefs = def.variableDefinitions;
            if (variableDefs != null) {
                variableDefs.forEach(function (variableDef) {
                    var varName = variableDef.variable.name.value;
                    // requirement for 'as NamedTypeNode' appears to be a bug within types, as function should take any TypeNode
                    var varType = typeFromAST(delegationContext.transformedSchema, variableDef.type);
                    variableValues[varName] = transformInputValue(varType, variableValues[varName], undefined, function (type, originalValue) {
                        var newValue = Object.create(null);
                        var fields = type.getFields();
                        Object.keys(originalValue).forEach(function (key) {
                            var _a;
                            var field = fields[key];
                            if (field != null) {
                                var newFieldName = (_a = _this.mapping[type.name]) === null || _a === void 0 ? void 0 : _a[field.name];
                                if (newFieldName != null) {
                                    newValue[newFieldName] = originalValue[field.name];
                                }
                                else {
                                    newValue[field.name] = originalValue[field.name];
                                }
                            }
                        });
                        return newValue;
                    });
                });
            }
        });
        originalRequest.document.definitions
            .filter(function (def) { return def.kind === Kind.FRAGMENT_DEFINITION; })
            .forEach(function (def) {
            fragments[def.name.value] = def;
        });
        var document = this.transformDocument(originalRequest.document, this.mapping, this.inputFieldNodeTransformer, this.inputObjectNodeTransformer, originalRequest, delegationContext);
        return __assign(__assign({}, originalRequest), { document: document, variables: variableValues });
    };
    TransformInputObjectFields.prototype.transformDocument = function (document, mapping, inputFieldNodeTransformer, inputObjectNodeTransformer, request, delegationContext) {
        var _a;
        var typeInfo = new TypeInfo(this.transformedSchema);
        var newDocument = visit(document, visitWithTypeInfo(typeInfo, {
            leave: (_a = {},
                _a[Kind.OBJECT] = function (node) {
                    var parentType = typeInfo.getInputType();
                    if (parentType != null) {
                        var parentTypeName_1 = parentType.name;
                        var newInputFields_1 = [];
                        node.fields.forEach(function (inputField) {
                            var newName = inputField.name.value;
                            var transformedInputField = inputFieldNodeTransformer != null
                                ? inputFieldNodeTransformer(parentTypeName_1, newName, inputField, request, delegationContext)
                                : inputField;
                            if (Array.isArray(transformedInputField)) {
                                transformedInputField.forEach(function (individualTransformedInputField) {
                                    var typeMapping = mapping[parentTypeName_1];
                                    if (typeMapping == null) {
                                        newInputFields_1.push(individualTransformedInputField);
                                        return;
                                    }
                                    var oldName = typeMapping[newName];
                                    if (oldName == null) {
                                        newInputFields_1.push(individualTransformedInputField);
                                        return;
                                    }
                                    newInputFields_1.push(__assign(__assign({}, individualTransformedInputField), { name: __assign(__assign({}, individualTransformedInputField.name), { value: oldName }) }));
                                });
                                return;
                            }
                            var typeMapping = mapping[parentTypeName_1];
                            if (typeMapping == null) {
                                newInputFields_1.push(transformedInputField);
                                return;
                            }
                            var oldName = typeMapping[newName];
                            if (oldName == null) {
                                newInputFields_1.push(transformedInputField);
                                return;
                            }
                            newInputFields_1.push(__assign(__assign({}, transformedInputField), { name: __assign(__assign({}, transformedInputField.name), { value: oldName }) }));
                        });
                        var newNode = __assign(__assign({}, node), { fields: newInputFields_1 });
                        return inputObjectNodeTransformer != null
                            ? inputObjectNodeTransformer(parentTypeName_1, newNode, request, delegationContext)
                            : newNode;
                    }
                },
                _a),
        }));
        return newDocument;
    };
    return TransformInputObjectFields;
}());
export default TransformInputObjectFields;
//# sourceMappingURL=TransformInputObjectFields.js.map